/* No cart, two buttons.

   1. Sweeps away anything leading to a cart or checkout. gs-nocart.css hides
      what has a stable name; this sweep catches the rest by what the control
      SAYS, because Horizon renames its custom elements between versions.
   2. Puts the two buttons on every card in the products hub, and a branded
      plate in any card whose product has no photograph yet.
   3. Puts them on the product page too, where the buy buttons used to be.
   4. Answers Buy now: asks permission, opens WhatsApp with the product, the
      chosen colour or pack size and a reference already written into the
      message box, and logs the click so sales@ gets an email and the sheet
      gets a row. The reference is generated here, not by the script, because
      the customer's message needs it the moment the dialog closes.

   DATASHEETS ARE NEVER SERVED FROM A PUBLIC PAGE. Tuttu's ruling, 5 October:
   "in no way the normal customers will get access to the TDSs." The datasheet
   button therefore has ONE behaviour — it opens the contact form with the
   product name already written in, and a human decides whether to send the
   sheet. There is no download branch, and no product page carries a PDF URL
   anywhere in its source, because a URL printed into the page is a published
   URL whether or not anything links it.

   This used to read product.metafields.custom.tds and, when that held a link,
   render "Download Datasheet" pointing straight at the file. Both halves are
   gone: the branch below, and the "tds" key the chrome snippet used to print
   into #gs-product-state. The metafield definition still exists and is empty
   on every product; filling it now does nothing. Technical data sheets belong
   to /pages/team, behind the staff tag — if a download button is wanted, it
   is built there, not here.

   Steps 1 and 2 rerun on a MutationObserver: Horizon rebuilds its product
   section on every variant change and the hub rebuilds its grid on every
   filter click.

   State: #gs-shop-state (number, contact page, logo) and #gs-relay-config
   (Apps Script endpoint and secret). With no endpoint the button still works,
   only the logging is skipped. */

(function () {
  'use strict';

  var S = { whatsapp: '', contact: '/pages/contact-us', logo: '' };
  var R = { endpoint: '', secret: '' };
  function read(id, into) {
    try {
      var el = document.getElementById(id);
      if (el) return Object.assign(into, JSON.parse(el.textContent));
    } catch (err) { /* defaults are usable */ }
    return into;
  }
  read('gs-shop-state', S);
  read('gs-relay-config', R);

  if (/^\/(cart|checkout)(\/|$)/.test(window.location.pathname)) {
    window.location.replace('/pages/products');
    return;
  }

  var DOC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z"/><path d="M14 3v4h4"/><path d="M12 11v6M9.5 14.5 12 17l2.5-2.5"/></svg>';
  var WA = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2m0 2a8 8 0 1 1-4.1 14.9l-.3-.2-2.6.7.7-2.5-.2-.3A8 8 0 0 1 12 4m-3.3 4c-.2 0-.5.1-.7.4-.2.3-.8.8-.8 2s.8 2.3.9 2.5c.1.2 1.6 2.6 4 3.5 1.9.8 2.3.6 2.8.6.4 0 1.4-.6 1.6-1.2.2-.6.2-1 .1-1.1l-.6-.3-1.5-.7c-.2-.1-.4-.1-.5.1l-.7.9c-.1.2-.3.2-.5.1a6.5 6.5 0 0 1-3.2-2.8c-.1-.2 0-.4.1-.5l.4-.5.3-.5v-.4l-.7-1.6c-.2-.4-.4-.4-.5-.4z"/></svg>';

  function tdsHref(title) {
    return S.contact + '?gs_msg=' +
      encodeURIComponent('Please send me the technical data sheet for ' + title + '.');
  }

  /* One behaviour only. Do not add a download branch here — see the note at
     the top of this file. */
  function pair(title, compact) {
    var wrap = document.createElement('div');
    wrap.className = compact ? 'gs-prod__acts' : 'gs-acts';

    var sheet = document.createElement('a');
    sheet.className = 'gs-btn gs-btn--ghost';
    sheet.href = tdsHref(title);
    sheet.innerHTML = DOC + '<span><span class="gs-btn__long">Request </span>Datasheet</span>';

    var buy = document.createElement('button');
    buy.type = 'button';
    buy.className = 'gs-btn gs-btn--wa';
    buy.dataset.gsWa = title;
    buy.innerHTML = WA + '<span>Buy now</span>';

    wrap.appendChild(sheet);
    wrap.appendChild(buy);
    return wrap;
  }

  window.GSButtons = { tdsHref: tdsHref, pair: pair };

  /* ------------------------------------------------------------- 1. sweep */

  var SELECTORS = [
    'cart-drawer', 'cart-drawer-component', 'cart-items-component', '.cart-drawer',
    '#cart-drawer', 'cart-icon', 'cart-icon-component', '.cart-bubble', '.cart-count',
    '.header-actions__cart-icon', 'a[href="/cart"]', 'a[href^="/cart?"]',
    'a[href="/checkout"]', 'add-to-cart-component', 'buy-buttons-component',
    'accelerated-checkout-component', 'shopify-accelerated-checkout',
    '.shopify-payment-button', 'product-form-buttons', '.product-form-buttons',
    '.product-form__buttons', '.product-form__submit', 'quantity-selector-component',
    '.quantity-selector', '.product-form__quantity', 'pickup-availability',
    'sticky-add-to-cart', '.sticky-add-to-cart',
    'product-price', '.product-price', '.price', '.price-list', '.card__price'
  ];

  var WORDS = /^(add to cart|add to bag|buy it now|buy now with|check ?out|view cart|my cart)/i;

  function hide(el) {
    if (!el || el.dataset.gsHidden === '1') return;
    el.dataset.gsHidden = '1';
    el.style.setProperty('display', 'none', 'important');
    el.setAttribute('aria-hidden', 'true');
  }

  function sweep() {
    SELECTORS.forEach(function (sel) {
      var found;
      try { found = document.querySelectorAll(sel); } catch (err) { return; }
      Array.prototype.forEach.call(found, hide);
    });

    var maybe = document.querySelectorAll('button, a.button, [type="submit"]');
    Array.prototype.forEach.call(maybe, function (el) {
      if (el.closest('.gs-acts, .gs-prod__acts, .gs-ask')) return;
      var text = (el.textContent || '').trim();
      if (text && WORDS.test(text)) hide(el.closest('.shopify-payment-button') || el);
    });
  }

  /* --------------------------------------------------------- 2. hub cards */

  function plate(media, title) {
    if (!media || media.querySelector('img, .gs-plate')) return;
    var box = document.createElement('span');
    box.className = 'gs-plate';
    box.innerHTML =
      (S.logo ? '<img src="' + S.logo + '" alt="">' : '') +
      '<span>Photograph coming</span>';
    box.setAttribute('aria-label', 'No photograph of ' + title + ' yet');
    media.appendChild(box);
  }

  function decorate() {
    var cards = document.querySelectorAll('.gs-prod');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.gsActs === '1') return;
      var nameEl = card.querySelector('.gs-prod__name');
      if (!nameEl) return;

      card.dataset.gsActs = '1';
      var title = (nameEl.textContent || '').trim();
      plate(card.querySelector('.gs-prod__media'), title);
      card.appendChild(pair(title, true));
    });
  }

  sweep();
  decorate();

  var pending = null;
  new MutationObserver(function () {
    window.clearTimeout(pending);
    pending = window.setTimeout(function () { sweep(); decorate(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------------------------------------------------- 3. the product page */

  var P = {};
  var state = document.getElementById('gs-product-state');
  if (state) {
    try { P = JSON.parse(state.textContent); } catch (err) { P = {}; }

    if (P.title) {
      var anchor =
        document.querySelector('.product-information, .product__info, .product-details') ||
        document.querySelector('main');

      if (anchor && !anchor.querySelector('.gs-acts')) {
        var after = anchor.querySelector('[data-gs-hidden="1"]') || anchor.querySelector('h1');
        var acts = pair(P.title, false);
        if (after && after.parentElement) {
          after.parentElement.insertBefore(acts, after.nextSibling);
        } else {
          anchor.appendChild(acts);
        }
      }
    }
  }

  /* Whatever the customer has picked in the variant cells, read at click time
     rather than cached, because Horizon rebuilds the picker on every change. */
  function chosen() {
    var out = [];
    var picked = document.querySelectorAll('.variant-picker input[type="radio"]:checked');
    Array.prototype.forEach.call(picked, function (input) {
      var name = input.dataset.optionName || '';
      var value = input.value || '';
      if (name && value && value !== 'Default Title') out.push({ name: name, value: value });
    });

    var selects = document.querySelectorAll('.variant-picker select.variant-option__select');
    Array.prototype.forEach.call(selects, function (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var name = (opt.dataset.optionName || '').trim();
      if (name && opt.value && opt.value !== 'Default Title') out.push({ name: name, value: opt.value });
    });

    return out;
  }

  /* --------------------------------------------------------- 4. the dialog */

  var ask = null;
  var wanted = '';

  function build() {
    ask = document.createElement('div');
    ask.className = 'gs-ask';
    ask.hidden = true;
    ask.innerHTML =
      '<div class="gs-ask__back" data-gs-ask-no></div>' +
      '<div class="gs-ask__card" role="dialog" aria-modal="true" aria-label="Continue to WhatsApp">' +
        '<span class="gs-ask__mark">' + WA + '</span>' +
        '<p class="gs-ask__title">We will connect you with our product expert</p>' +
        '<p class="gs-ask__text" data-gs-ask-text></p>' +
        '<div class="gs-ask__row">' +
          '<button type="button" class="gs-btn gs-btn--plain" data-gs-ask-no>Not now</button>' +
          '<button type="button" class="gs-btn gs-btn--wa" data-gs-ask-yes>Continue</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(ask);

    ask.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      if (event.target.closest('[data-gs-ask-no]')) close();
      if (event.target.closest('[data-gs-ask-yes]')) go();
    });
  }

  function close() {
    if (ask) ask.hidden = true;
    document.body.style.overflow = '';
  }

  function ref() {
    var n = Date.now().toString(36).toUpperCase();
    return 'GS-W-' + n.slice(-5) + Math.floor(Math.random() * 36).toString(36).toUpperCase();
  }

  /* sendBeacon survives the tab that opens a moment later. text/plain keeps it
     a simple request, so Apps Script answers it without a CORS preflight. */
  function log(payload) {
    if (!R.endpoint) return;
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(R.endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
        return;
      }
    } catch (err) { /* fall through */ }
    try {
      fetch(R.endpoint, { method: 'POST', mode: 'no-cors', keepalive: true, body: body });
    } catch (err) { /* logging is never allowed to block the customer */ }
  }

  function go() {
    close();
    if (!S.whatsapp) return;

    var picks = chosen();
    var code = ref();

    var lines = ['Hello Grandseal, I would like to order:', '', 'Product: ' + (wanted || 'see below')];
    picks.forEach(function (p) { lines.push(p.name + ': ' + p.value); });
    lines.push('Reference: ' + code);
    lines.push('');
    lines.push('Please send me the price and availability.');

    log({
      secret: R.secret,
      kind: 'whatsapp',
      reference: code,
      product: wanted,
      options: picks.map(function (p) { return p.name + ': ' + p.value; }).join(', '),
      handle: P.handle || '',
      page: window.location.href
    });

    window.open(S.whatsapp + '?text=' + encodeURIComponent(lines.join('\n')), '_blank', 'noopener');
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-gs-wa]') : null;
    if (!btn) return;
    event.preventDefault();

    wanted = btn.dataset.gsWa || '';
    if (!ask) build();

    var picks = chosen();
    var what = wanted;
    if (picks.length) what += ' (' + picks.map(function (p) { return p.value; }).join(', ') + ')';

    ask.querySelector('[data-gs-ask-text]').textContent = wanted
      ? 'WhatsApp opens with a message about ' + what + ' ready for you to send. Our team answers with price, pack sizes and availability.'
      : 'WhatsApp opens so our team can answer with price, pack sizes and availability.';

    ask.hidden = false;
    document.body.style.overflow = 'hidden';
    ask.querySelector('[data-gs-ask-yes]').focus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && ask && !ask.hidden) close();
  });
})();
